/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { $t } from "App/IOC";
import { Column, CustomError } from "App/Models";
import Columns from "App/UseCases/Columns";

let sort: Column;
let columns: Column[] = [];

function GetDefaultSort(): Column {
    if( sort === undefined )
        sort = new Column( "LastName", $t( "CONSOLE_USERS_columnName" ) );

    return sort;
}

function getDefault(): Column[] {
    if( columns.length === 0 )
        columns = [
            new Column( "DisplayName", $t( "CONSOLE_USERS_columnName" ) ),
            new Column( "Email", $t( "CONSOLE_USERS_columnEmail" ) ),
            new Column( "Phone", $t( "CONSOLE_USERS_columnPhone" ) ),
            new Column( "RoleName", $t( "CONSOLE_USERS_columnRole" ) ),
            new Column( "StateLabel", $t( "CONSOLE_USERS_columnState" ) )
        ];

    return columns;
}

async function Get(): Promise<[ Column[], CustomError | undefined ]> {
    return await Columns.Get( "ConsoleUsers", getDefault() );
}

async function Toggle( existingColumn: Column ): Promise<CustomError | undefined> {
    return await Columns.Toggle( "ConsoleUsers", existingColumn, getDefault() );
}

export default {
    GetDefaultSort,
    Get,
    Toggle
};
